export default __webpack_public_path__ + "static/media/lighttening.59cf167d.png";